exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".aboutus{font-family:Segoe UI;font-size:10pt}h1{font-weight:700;color:#0073a3;font-size:15pt;padding-top:0}h1 em{display:block;font-size:10pt}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/aboutus.css
 ** module id = 484
 ** module chunks = 0
 **/